<div class="kf-editable-field">
    <div class="d-flex
         {{'kf-field-xs-' + labelCols}}
         {{'kf-field-sm-' + labelColsSm}}
         {{'kf-field-md-' + labelColsMd}}
         {{'kf-field-lg-' + labelColsLg}}
         {{'kf-field-xl-' + labelColsXl}}
         {{'kf-field-xxl-' + labelColsXxl}}">
        <div class="kf-input-label">
            <label for="{{id}}">
                {{label}}
                @if (helpText) {
                    <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                        <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                    </span>
                }
            </label>
        </div>
        
        <!-- MULTI-SELECT VERSION -->
        <!-- THIS IS A HACK. I've copied all the code here to make a multiselect version of this widget
        because it turns out it's not so each to just add a "multiple" attribute to the <select>.
        Let's gett his working later so we're not repeating all this code. Meantime, let's be sure we
        keep this code updated here and below
        This sort of attribute just does not work: [attr.multiple]="(maxSelectionCount > 1) ? '' : null"
        -->
        <div class="kf-input col">
            @if ((maxSelectionCount > 1)) {
                <select class="select-dropdown select-multi w-100"
                        [class.select-disabled]="!(isEditable$ | async)"
                        [id]="id"
                        [ngModel]="obj[prop]"
                        (ngModelChange)="obj[prop]=$event;validate();"
                        (change)="onChange($event)"
                        size="{{(!(isEditable$ | async) && (obj[prop]?.length < optionsToShow)) ? obj[prop]?.length : optionsToShow}}"
                        multiple
                        disabled="{{ !(isEditable$ | async) }}">
                    <!-- this line is the only different between this block at the single select one below -->
                    @if (optionList$ | async; as options) {
                        @for (option of options; track option.displayName) {
                            <!--  For non-grouped options  -->
                            @if (!option.isGroup) {
                                <option class="option-dropdown" [ngValue]="option.value" [disabled]="option.disabled" [hidden]="option.hidden">
                                    {{option.displayName}}
                                </option>
                            }
                            <!--  For grouped options  -->
                            @if (option.isGroup && option.value) {
                                <optgroup label="{{option.displayName}}">
                                    @for (subItem of option.value; track subItem.displayName) {
                                        <option class="option-dropdown" [ngValue]="subItem.value" [disabled]="subItem.disabled" [hidden]="option.hidden">
                                            {{subItem.displayName}}
                                        </option>
                                    }
                                </optgroup>
                            }
                        }
                    }
                </select>
            }
            
            <!-- SINGLE-SELECT VERSION -->
            @if ((maxSelectionCount == 1)) {
                <select class="select-dropdown w-100"
                        [class.select-disabled]="!(isEditable$ | async)"
                        [class.text-truncate]="(maxSelectionCount != 0) || (isEditable$ | async)"
                        [id]="id"
                        [ngModel]="obj[prop]"
                        (ngModelChange)="this.obj[this.prop]=$event;this.validate();"
                        (change)="onChange($event)"
                        size="{{optionsToShow}}"
                        disabled="{{(maxSelectionCount == 0) || !(isEditable$ | async) }}">
                    <!-- this line is the only different between this block at the single select one below -->
                    @if (optionList$ | async; as options) {
                        @for (option of options; track option.id) {
                            <!--  For non-grouped options  -->
                            @if (!option.isGroup) {
                                <option class="option-dropdown" [ngValue]="option.value" [disabled]="option.disabled" [hidden]="option.hidden">
                                    {{option.displayName}}
                                </option>
                            }
                            <!--  For grouped options  -->
                            @if (option.isGroup && option.value) {
                                <optgroup label="{{option.displayName}}">
                                    @for (subItem of option.value; track subItem.id) {
                                        <option class="option-dropdown" [ngValue]="subItem.value" [disabled]="subItem.disabled" [hidden]="option.hidden">
                                            {{subItem.displayName}}
                                        </option>
                                    }
                                </optgroup>
                            }
                        }
                    }
                </select>
            }
        </div>
    </div>
    
    <!--  Errors/Warnings  -->
    @if (isEditable$ | async) {
        <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true"></observable-errors-warnings>
    }
    @else{
        @if(allowReadOnlyWarnings){
            <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true" [supressErrors]="true"></observable-errors-warnings>
        }
    }
</div>
